import {gl} from '../../globals';

abstract class Drawable {
  count: number = 0;

  bufIdx: WebGLBuffer;
  bufPos: WebGLBuffer;
  bufNor: WebGLBuffer;
  bufCol: WebGLBuffer;
  buf_bcCoord: WebGLBuffer;
  bufUvCoord: WebGLBuffer;

  idxBound: boolean = false;
  posBound: boolean = false;
  norBound: boolean = false;
  colBound: boolean = false;
  bcCoordBound: boolean = false;
  uvCoordBound: boolean = false;

  abstract create() : void;

  destory() {
    gl.deleteBuffer(this.bufIdx);
    gl.deleteBuffer(this.bufPos);
    gl.deleteBuffer(this.bufNor);
    gl.deleteBuffer(this.bufCol);
    gl.deleteBuffer(this.buf_bcCoord);
    gl.deleteBuffer(this.bufUvCoord);
  }

  generateIdx() {
    this.idxBound = true;
    this.bufIdx = gl.createBuffer();
  }

  generatePos() {
    this.posBound = true;
    this.bufPos = gl.createBuffer();
  }

  generateNor() {
    this.norBound = true;
    this.bufNor = gl.createBuffer();
  }

  generateCol() {
    this.colBound = true;
    this.bufCol = gl.createBuffer();
  }

  generateBcCoord() {
    this.bcCoordBound = true;
    this.buf_bcCoord = gl.createBuffer();
  }

  generateUvCoord() {
    this.uvCoordBound = true;
    this.bufUvCoord = gl.createBuffer();
  }

  bindIdx(): boolean {
    if (this.idxBound) {
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.bufIdx);
    }
    return this.idxBound;
  }

  bindPos(): boolean {
    if (this.posBound) {
      gl.bindBuffer(gl.ARRAY_BUFFER, this.bufPos);
    }
    return this.posBound;
  }

  bindNor(): boolean {
    if (this.norBound) {
      gl.bindBuffer(gl.ARRAY_BUFFER, this.bufNor);
    }
    return this.norBound;
  }

  bindCol(): boolean {
    if (this.colBound) {
      gl.bindBuffer(gl.ARRAY_BUFFER, this.bufCol);
    }
    return this.colBound;
  }

  bindBcCoord(): boolean {
    if (this.bcCoordBound) {
      gl.bindBuffer(gl.ARRAY_BUFFER, this.buf_bcCoord);
    }
    return this.bcCoordBound;
  }

  bindUvCoord(): boolean {
    if (this.uvCoordBound) {
      gl.bindBuffer(gl.ARRAY_BUFFER, this.bufUvCoord);
    }
    return this.uvCoordBound;
  }

  elemCount(): number {
    return this.count;
  }

  drawMode(): GLenum {
    return gl.TRIANGLES;
  }
};

export default Drawable;



// WEBPACK FOOTER //
// ./src/rendering/gl/Drawable.ts